import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFilePreviewSplitPanelState } from "./definitions";
import { DocumentCollection } from "components/documents-table/version-utils";

const initialState: IFilePreviewSplitPanelState = {
  selectedDocumentId: null,
  isOpen: false,
  gaiaObjectType: undefined,
  documentCollection: null,
};

export const filePreviewSplitPanelSlice = createSlice({
  name: "filePreviewSplitPanel",
  initialState,
  reducers: {
    setSelectedDocumentId: (state, action: PayloadAction<string | null>) => {
      state.selectedDocumentId = action.payload;
    },
    setSplitPanelOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    setGaiaObjectType: (state, action: PayloadAction<string | undefined>) => {
      state.gaiaObjectType = action.payload;
    },
    setDocumentCollection: (
      state,
      action: PayloadAction<DocumentCollection | null>
    ) => {
      state.documentCollection = action.payload;
    },
  },
});

export const {
  setSelectedDocumentId,
  setSplitPanelOpen,
  setGaiaObjectType,
  setDocumentCollection,
} = filePreviewSplitPanelSlice.actions;

export default filePreviewSplitPanelSlice.reducer;
